<template>
    <div
        class="ToDo"
        :style="styles"
    >
        <WText
            v-if="name"
            size="14"
            weight="bold"
            class="Name"
        >
            {{ name }}
        </WText>
        <WText
            v-if="description"
            size="14"
            weight="light"
            class="Description"
        >
            {{ description }}
        </WText>

        <slot />
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'ToDo',
    props: {
        name: VueTypes.string.isRequired,
        description: VueTypes.string.optional,
        height: VueTypes.oneOfType([String, Number]).isRequired,
        width: VueTypes.oneOfType([String, Number]).optional,
        circle: VueTypes.bool.def(false),
    },
    computed: {
        styles () {
            return {
                width: this.width ? `${this.width}px` : undefined,
                height: `${this.height}px`,
                ...this.circleStyles,
            }
        },
        circleStyles () {
            return this.circle ? {
                width: `${this.height}px`,
                borderRadius: '50%',
            } : {}
        },
    },
}
</script>
<style lang="scss" scoped>
.ToDo {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
    background: $gray-light;

	.Name {
		margin-bottom: 0px;
	}
	.Description {
		margin-top: 15px;
		margin-bottom: 0px;
	}
}
</style>
